import React from "react";

// Home services images - all unique
const homeServicesImages = [
  {
    name: "Plumbing",
    image: "https://images.unsplash.com/photo-1635221798248-8a3452ad07cd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwyfHxob21lJTIwc2VydmljZXMlMjBwbHVtYmVyJTIwZWxlY3RyaWNpYW4lMjBodmFjJTIwcmVwYWlyfGVufDB8fHx8MTc3MzQ5MTg1OHww&ixlib=rb-4.1.0&q=85"
  },
  {
    name: "Electrical",
    image: "https://images.unsplash.com/photo-1621905251918-48416bd8575a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwxfHxob21lJTIwc2VydmljZXMlMjBwbHVtYmVyJTIwZWxlY3RyaWNpYW4lMjBodmFjJTIwcmVwYWlyfGVufDB8fHx8MTc3MzQ5MTg1OHww&ixlib=rb-4.1.0&q=85"
  },
  {
    name: "Roofing",
    image: "https://images.unsplash.com/photo-1681049400158-0ff6249ac315?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxyb29maW5nJTIwY29udHJhY3RvciUyMHJvb2YlMjByZXBhaXIlMjBjb25zdHJ1Y3Rpb258ZW58MHx8fHwxNzczNDkxODYzfDA&ixlib=rb-4.1.0&q=85"
  },
  {
    name: "HVAC",
    image: "https://images.unsplash.com/photo-1729183672500-46c52a897de5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwyfHxhaXIlMjBjb25kaXRpb25pbmclMjBodmFjJTIwdGVjaG5pY2lhbiUyMGluc3RhbGxhdGlvbnxlbnwwfHx8fDE3NzM0OTE4Njl8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    name: "Pest Control",
    image: "https://images.unsplash.com/photo-1742483359033-13315b247c74?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwyfHxwZXN0JTIwY29udHJvbCUyMGV4dGVybWluYXRvciUyMGhvbWUlMjBjbGVhbmluZyUyMHNlcnZpY2V8ZW58MHx8fHwxNzczNDkxODc0fDA&ixlib=rb-4.1.0&q=85"
  },
  {
    name: "Garage Door",
    image: "https://images.unsplash.com/photo-1675747158954-4a32e28812c0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwyfHxnYXJhZ2UlMjBkb29yJTIwcmVwYWlyJTIwd2luZG93JTIwcmVwbGFjZW1lbnR8ZW58MHx8fHwxNzczNDkxODc5fDA&ixlib=rb-4.1.0&q=85"
  },
  {
    name: "Solar",
    image: "https://images.unsplash.com/photo-1763114613273-ec505136d03a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwyfHxzb2xhciUyMHBhbmVsJTIwaW5zdGFsbGF0aW9uJTIwaG9tZXxlbnwwfHx8fDE3NzM0OTE4OTB8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    name: "Windows",
    image: "https://images.unsplash.com/photo-1607888941203-015b3576def0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHw0fHxnYXJhZ2UlMjBkb29yJTIwcmVwYWlyJTIwd2luZG93JTIwcmVwbGFjZW1lbnR8ZW58MHx8fHwxNzczNDkxODc5fDA&ixlib=rb-4.1.0&q=85"
  },
  {
    name: "Roof Repair",
    image: "https://images.unsplash.com/photo-1635424709845-3a85ad5e1f5e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHw0fHxyb29maW5nJTIwY29udHJhY3RvciUyMHJvb2YlMjByZXBhaXIlMjBjb25zdHJ1Y3Rpb258ZW58MHx8fHwxNzczNDkxODYzfDA&ixlib=rb-4.1.0&q=85"
  },
  {
    name: "Floor Cleaning",
    image: "https://images.unsplash.com/photo-1615863592076-4659e115b0a8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHw0fHxwZXN0JTIwY29udHJvbCUyMGV4dGVybWluYXRvciUyMGhvbWUlMjBjbGVhbmluZyUyMHNlcnZpY2V8ZW58MHx8fHwxNzczNDkxODc0fDA&ixlib=rb-4.1.0&q=85"
  },
  {
    name: "Wiring",
    image: "https://images.unsplash.com/photo-1768321911908-01c691fcc5a0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHw0fHxob21lJTIwc2VydmljZXMlMjBwbHVtYmVyJTIwZWxlY3RyaWNpYW4lMjBodmFjJTIwcmVwYWlyfGVufDB8fHx8MTc3MzQ5MTg1OHww&ixlib=rb-4.1.0&q=85"
  },
  {
    name: "AC Unit",
    image: "https://images.unsplash.com/photo-1709432767122-d3cb5326911a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHxhaXIlMjBjb25kaXRpb25pbmclMjBodmFjJTIwdGVjaG5pY2lhbiUyMGluc3RhbGxhdGlvbnxlbnwwfHx8fDE3NzM0OTE4Njl8MA&ixlib=rb-4.1.0&q=85"
  }
];

const OfferImagesRail = () => {
  // Triple the images for seamless loop
  const tripledImages = [...homeServicesImages, ...homeServicesImages, ...homeServicesImages];

  return (
    <div className="py-8 bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900 overflow-hidden" data-testid="offer-images-rail">
      <div className="max-w-7xl mx-auto px-4 mb-6">
        <p className="text-center text-blue-400 text-sm uppercase tracking-wider font-semibold">
          Home Services We Cover
        </p>
      </div>
      
      <div className="flex items-center">
        <div className="flex animate-scroll-images">
          {tripledImages.map((service, index) => (
            <div
              key={index}
              className="flex-shrink-0 mx-3 group"
            >
              <div className="w-56 h-36 rounded-xl overflow-hidden shadow-lg relative border border-white/10">
                <img 
                  src={service.image} 
                  alt={service.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                <div className="absolute bottom-3 left-3 right-3">
                  <p className="text-white font-bold text-base drop-shadow-lg">{service.name}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      
      <style jsx="true">{`
        @keyframes scroll-images {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-33.33%);
          }
        }
        .animate-scroll-images {
          animation: scroll-images 40s linear infinite;
        }
        .animate-scroll-images:hover {
          animation-play-state: paused;
        }
      `}</style>
    </div>
  );
};

export default OfferImagesRail;
